export default __webpack_public_path__ + "static/media/MH-SHIRT-BACK.06666d8e.png";